import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useUnsavedChangesStore } from '../stores/useUnsavedChangesStore';
import { Button, ButtonVariants } from './Button';
import { Modal } from './Modal';
import { TextReg } from './StyledText';

export function UnsavedChangesModal() {
  const { isModalVisible, confirmDiscard, cancelDiscard } =
    useUnsavedChangesStore();

  return (
    <Modal
      visible={isModalVisible}
      hide={cancelDiscard}
      title="Unsaved Changes"
      size="small"
    >
      <View style={styles.content}>
        <TextReg style={styles.message}>
          {"You've made changes that won't be saved if you leave this page."}
        </TextReg>
        <View style={styles.buttonContainer}>
          <Button variant={ButtonVariants.WHITE} onPress={confirmDiscard}>
            Discard
          </Button>
          <Button variant={ButtonVariants.PURPLE} onPress={cancelDiscard}>
            Continue Editing
          </Button>
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  content: {
    width: '100%',
    gap: 24,
  },
  message: {
    textAlign: 'center',
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: 12,
  },
});
